import {StyleSheet, View, ViewStyle} from "react-native";
import {ReactNode} from "react";

type Props = {
    left: ReactNode,
    right: ReactNode,
    style?: ViewStyle,
}

export default function Split({left, right, style}: Props) {
    return (
        <View style={[styles.container, style]}>
            <View style={styles.left}>
                {left}
            </View>
            <View style={styles.right}>
                {right}
            </View>
        </View>
    )
}

export const styles = StyleSheet.create({
    container: {
        flexDirection: "row",
        width: "100%",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 16,
    },
    left: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "flex-start",
        flexGrow: 1,
        gap: 8,
    },
    right: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "flex-end",
        gap: 8,
    },
})